const API = process.env.SVELTE_APP_API || 'http://localhost:7071/api';

export { API as default };
